// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../sfd-v2/node_modules/css-loader/dist/cjs.js!../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epx-dmn-expr {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--epx-dmn-panel-bg);
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: var(--epx-dmn-panel-text);
  padding: 0;
  box-sizing: border-box;
}

.epx-dmn-expr__wrap {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.epx-dmn-expr__main {
  flex: 1;
  min-width: 0;
  overflow: auto;
  padding: 16px;
  box-sizing: border-box;
}

.epx-dmn-expr__empty,
.epx-dmn-expr__redirect,
.epx-dmn-expr__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: var(--epx-dmn-panel-text-faint);
  font-style: italic;
}
.epx-dmn-expr__placeholder {
  color: var(--epx-dmn-danger);
}

.epx-dmn-expr__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.epx-dmn-expr__title {
  font-weight: 600;
  font-size: 15px;
  color: var(--epx-dmn-panel-text);
}

.epx-dmn-expr__type-chip {
  display: inline-block;
  padding: 2px 10px;
  background: var(--epx-dmn-accent);
  color: #fff;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
}
.epx-dmn-expr__type-chip:hover {
  background: var(--epx-dmn-accent-hover);
}
.epx-dmn-expr__type-chip--readonly {
  background: var(--epx-dmn-panel-border);
  color: var(--epx-dmn-panel-text-muted);
  cursor: default;
}
.epx-dmn-expr__type-chip--readonly:hover {
  background: var(--epx-dmn-panel-border);
}

.epx-dmn-expr__body {
  display: block;
}

/* ── generic box ──────────────────────────────────────────────────────── */
.epx-dmn-expr__box {
  border: 1px solid var(--epx-dmn-grid-border);
  background: var(--epx-dmn-panel-bg);
  margin: 0;
  display: inline-block;
  min-width: 240px;
  vertical-align: top;
}
.epx-dmn-expr__box--literal {
  padding: 0;
}

/* Top-level boxed expression fills the available width of the editor. */
.epx-dmn-expr__body > .epx-dmn-expr__box {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.epx-dmn-expr__grid {
  border-collapse: collapse;
  width: 100%;
}
.epx-dmn-expr__grid th,
.epx-dmn-expr__grid td {
  border: 1px solid var(--epx-dmn-grid-border);
  padding: 0;
  vertical-align: top;
  background: var(--epx-dmn-panel-bg);
  position: relative;
}

.epx-dmn-expr__name {
  width: 140px;
  min-width: 100px;
  background: var(--epx-dmn-grid-header-bg);
  font-weight: 600;
}

.epx-dmn-expr__name--result.epx-dmn-expr__editable--empty::before {
  font-style: italic;
  opacity: 0.7;
}

.epx-dmn-expr__cell {
  padding: 0;
  min-width: 180px;
}

.epx-dmn-expr__type {
  width: 80px;
  text-align: center;
  background: var(--epx-dmn-grid-zebra);
  vertical-align: middle;
  padding: 2px 4px !important;
}

.epx-dmn-expr__index {
  width: 26px;
  min-width: 26px;
  text-align: center;
  background: var(--epx-dmn-grid-index-bg);
  color: var(--epx-dmn-panel-text-muted);
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
}
.epx-dmn-expr__index:hover {
  background: var(--epx-dmn-danger-soft);
  color: var(--epx-dmn-danger);
}

.epx-dmn-expr__row-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 16px;
  height: 16px;
  line-height: 14px;
  font-size: 14px;
  border: none;
  background: transparent;
  color: var(--epx-dmn-panel-text-muted);
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
}
.epx-dmn-expr__row-remove:hover {
  background: var(--epx-dmn-danger);
  color: #fff;
}

.epx-dmn-expr__add-row {
  text-align: center;
  color: var(--epx-dmn-accent);
  cursor: pointer;
  padding: 6px !important;
  background: var(--epx-dmn-grid-zebra) !important;
  user-select: none;
}
.epx-dmn-expr__add-row:hover { background: var(--epx-dmn-grid-header-bg) !important; }

/* ── editable cells ───────────────────────────────────────────────────── */
.epx-dmn-expr__editable {
  display: block;
  padding: 6px 8px;
  min-height: 22px;
  outline: none;
  font-family: "Menlo", "Consolas", "Courier New", monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
  cursor: text;
}
.epx-dmn-expr__editable:focus {
  background: var(--epx-dmn-focus-bg);
  box-shadow: inset 0 0 0 2px var(--epx-dmn-accent);
}
.epx-dmn-expr__editable--empty::before {
  content: attr(data-placeholder);
  color: var(--epx-dmn-panel-text-faint);
}
.epx-dmn-expr__name .epx-dmn-expr__editable {
  font-family: inherit;
  font-weight: 600;
  padding: 6px 20px 6px 8px;
}

/* ── invocation ───────────────────────────────────────────────────────── */
.epx-dmn-expr__box--invocation .epx-dmn-expr__invocation-header {
  background: var(--epx-dmn-bkm-fill);
  border-bottom: 1px solid var(--epx-dmn-grid-border);
  padding: 0;
}
.epx-dmn-expr__invocation-name {
  font-family: inherit !important;
  font-weight: 700;
  font-style: italic;
}

/* ── relation ─────────────────────────────────────────────────────────── */
.epx-dmn-expr__relation thead th {
  background: var(--epx-dmn-grid-header-bg);
  font-weight: 600;
}
.epx-dmn-expr__relation-corner {
  width: 26px;
  background: var(--epx-dmn-panel-border) !important;
}
.epx-dmn-expr__relation-head {
  min-width: 120px;
  padding: 0 20px 0 4px !important;
}
.epx-dmn-expr__relation-tail {
  width: 26px;
  background: var(--epx-dmn-grid-zebra);
}
.epx-dmn-expr__add-col {
  width: 26px;
  text-align: center;
  cursor: pointer;
  background: var(--epx-dmn-grid-zebra) !important;
  color: var(--epx-dmn-accent);
  font-size: 16px;
  user-select: none;
}
.epx-dmn-expr__add-col:hover { background: var(--epx-dmn-grid-header-bg) !important; }

/* ── function definition ──────────────────────────────────────────────── */
.epx-dmn-expr__box--function {
  padding: 0;
}
.epx-dmn-expr__fn-params {
  background: var(--epx-dmn-ks-fill);
  border-bottom: 1px solid var(--epx-dmn-grid-border);
  padding: 6px 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.epx-dmn-expr__fn-label {
  font-weight: 700;
  color: var(--epx-dmn-ks-stroke);
  margin-right: 8px;
}
.epx-dmn-expr__fn-param {
  display: inline-flex;
  align-items: center;
  background: var(--epx-dmn-panel-bg);
  border: 1px solid var(--epx-dmn-ks-stroke);
  border-radius: 3px;
  padding-right: 20px;
  position: relative;
}
.epx-dmn-expr__fn-param .epx-dmn-expr__editable {
  padding: 2px 8px;
  font-family: inherit;
  font-weight: 600;
}
.epx-dmn-expr__fn-typeref {
  color: var(--epx-dmn-panel-text-muted);
  padding-right: 2px;
  font-size: 11px;
}
.epx-dmn-expr__fn-typeselect {
  font-size: 11px;
  padding: 1px 4px;
  border: 1px solid var(--epx-dmn-input-border);
  border-radius: 3px;
  background: var(--epx-dmn-input-bg);
  color: var(--epx-dmn-panel-text);
  margin-right: 4px;
}
.epx-dmn-expr__fn-add {
  background: none;
  border: 1px dashed var(--epx-dmn-ks-stroke);
  border-radius: 3px;
  color: var(--epx-dmn-ks-stroke);
  padding: 2px 8px;
  cursor: pointer;
}
.epx-dmn-expr__fn-add:hover { background: var(--epx-dmn-ks-fill); }
.epx-dmn-expr__fn-body {
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.epx-dmn-expr__fn-body-type { margin-left: auto; }

/* ── type picker ─────────────────────────────────────────────────────── */
.epx-dmn-expr__type-picker {
  display: inline-block;
}
.epx-dmn-expr__type-btn {
  background: var(--epx-dmn-panel-bg);
  border: 1px solid var(--epx-dmn-input-border);
  border-radius: 3px;
  font-size: 11px;
  padding: 2px 6px;
  cursor: pointer;
  color: var(--epx-dmn-panel-text-muted);
}
.epx-dmn-expr__type-btn:hover {
  background: var(--epx-dmn-accent-bg);
  border-color: var(--epx-dmn-accent);
  color: var(--epx-dmn-accent);
}

.epx-dmn-expr__type-menu {
  position: fixed;
  min-width: 180px;
  background: var(--epx-dmn-panel-bg);
  border: 1px solid var(--epx-dmn-panel-border);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 10010;
  padding: 4px 0;
}
.epx-dmn-expr__type-menu-item {
  display: block;
  width: 100%;
  padding: 5px 14px;
  font-size: 12px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  color: var(--epx-dmn-panel-text);
}
.epx-dmn-expr__type-menu-item:hover { background: var(--epx-dmn-grid-header-bg); }
.epx-dmn-expr__type-menu-item.is-active { background: var(--epx-dmn-accent); color: #fff; }
.epx-dmn-expr__type-menu-sep {
  padding: 4px 14px 2px;
  margin-top: 4px;
  border-top: 1px solid var(--epx-dmn-panel-border);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--epx-dmn-panel-text-muted, #888);
  pointer-events: none;
  user-select: none;
}

/* ── EPX ML decision editor ─────────────────────────────────────────────── */
.epx-dmn-expr__box--ml {
  display: block;
  padding: 8px;
  background: var(--epx-dmn-panel-bg);
  border: 1px solid #c41d7f;
  border-radius: 4px;
}
.epx-dmn-expr__ml-section {
  margin-bottom: 12px;
}
.epx-dmn-expr__ml-section:last-child { margin-bottom: 0; }
.epx-dmn-expr__ml-section-title {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  color: #c41d7f;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.epx-dmn-expr__ml-field {
  display: grid;
  grid-template-columns: 140px 1fr;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.epx-dmn-expr__ml-field-label {
  font-size: 12px;
  color: var(--epx-dmn-panel-text);
}
.epx-dmn-expr__ml-input {
  width: 100%;
  font-size: 12px;
  padding: 4px 6px;
  border: 1px solid var(--epx-dmn-panel-border);
  border-radius: 3px;
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-panel-text);
  box-sizing: border-box;
}
.epx-dmn-expr__ml-input--number { width: 120px; }
.epx-dmn-expr__ml-typeselect {
  font-size: 12px;
  padding: 3px 6px;
  border: 1px solid var(--epx-dmn-panel-border);
  border-radius: 3px;
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-panel-text);
}
.epx-dmn-expr__ml-grid th {
  font-size: 11px;
  font-weight: 600;
  text-align: left;
  padding: 4px 6px;
  color: var(--epx-dmn-panel-text);
  background: var(--epx-dmn-grid-header-bg);
}
.epx-dmn-expr__ml-tools {
  margin-top: 6px;
}
.epx-dmn-expr__ml-suggest {
  font-size: 11px;
  padding: 4px 10px;
  border: 1px solid #c41d7f;
  background: #fff0f6;
  color: #c41d7f;
  border-radius: 3px;
  cursor: pointer;
}
.epx-dmn-expr__ml-suggest:hover { background: #ffd6e7; }
.epx-dmn-expr__ml-radios {
  display: flex;
  gap: 12px;
  margin-bottom: 6px;
}
.epx-dmn-expr__ml-radio {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  cursor: pointer;
}
.epx-dmn-expr__ml-fallback-value {
  margin-top: 4px;
}

/* nested boxes: don't double-border when a box sits inside a cell */
.epx-dmn-expr__cell > .epx-dmn-expr__box {
  display: block;
  min-width: auto;
  border: none;
}
.epx-dmn-expr__cell > .epx-dmn-expr__box--literal {
  min-width: 180px;
}

/* ── FEEL chips (rendered inside .epx-dmn-expr__editable on blur) ─────── */
.epx-dmn-feel-chip {
  display: inline-block;
  padding: 0 6px;
  margin: 0 1px;
  border-radius: 4px;
  border: 1px solid var(--epx-dmn-panel-border);
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-panel-text);
  font-weight: 600;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11px;
  line-height: 1.6;
  vertical-align: baseline;
  user-select: none;
}
.epx-dmn-feel-chip--input    { border-color: var(--epx-dmn-input-stroke);    background: var(--epx-dmn-input-fill); }
.epx-dmn-feel-chip--decision { border-color: var(--epx-dmn-decision-stroke); background: var(--epx-dmn-decision-fill); }
.epx-dmn-feel-chip--function { border-color: var(--epx-dmn-bkm-stroke);      background: var(--epx-dmn-bkm-fill); }
.epx-dmn-feel-chip--param    { border-color: var(--epx-dmn-ks-stroke);       background: var(--epx-dmn-ks-fill); }
.epx-dmn-feel-chip--self     { border-style: dashed; }
.epx-dmn-feel-chip--known    {
  border-color: var(--epx-dmn-accent);
  background:   var(--epx-dmn-accent-bg-soft);
  color:        var(--epx-dmn-accent-text);
}
.epx-dmn-feel-chip--unknown  {
  border-color: var(--epx-dmn-unknown-stroke);
  background:   var(--epx-dmn-unknown-soft);
  color:        var(--epx-dmn-unknown-text);
  border-style: dashed;
  font-style:   italic;
}
.epx-dmn-feel-builtin {
  color: var(--epx-dmn-bkm-stroke);
  font-weight: 600;
}

/* ── FEEL syntax tokens (colors only, no chip box) ───────────────────── */
.epx-dmn-feel-tok--keyword {
  color: var(--epx-dmn-feel-keyword);
  font-weight: 700;
}
.epx-dmn-feel-tok--literal {
  color: var(--epx-dmn-feel-literal);
  font-style: italic;
}
.epx-dmn-feel-tok--number {
  color: var(--epx-dmn-feel-number);
  font-weight: 600;
}
.epx-dmn-feel-tok--string {
  color: var(--epx-dmn-feel-string);
}
.epx-dmn-feel-tok--op {
  color: var(--epx-dmn-feel-op);
  font-weight: 600;
}
.epx-dmn-feel-tok--punct {
  color: var(--epx-dmn-panel-text-faint);
}
.epx-dmn-feel-tok--label {
  color: var(--epx-dmn-panel-text-faint, #555);
  font-weight: 600;
}

/* ── Chip de typeRef en context entries / invocation bindings ─────────── */
.epx-dmn-expr__type-chip {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.04);
  font-size: 11px;
  color: var(--epx-dmn-panel-text-faint, #555);
  cursor: pointer;
  user-select: none;
}
.epx-dmn-expr__type-chip:hover { background: rgba(0, 0, 0, 0.08); }

.epx-dmn-expr__type-popover {
  position: absolute;
  z-index: 1000;
  background: var(--epx-dmn-panel-bg, #fff);
  color: var(--epx-dmn-panel-text, #1e293b);
  border: 1px solid var(--epx-dmn-panel-border, #d9d9d9);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  padding: 4px;
  min-width: 120px;
}
.epx-dmn-expr__type-popover button {
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 3px;
  font-size: 12px;
}
.epx-dmn-expr__type-popover button:hover { background: rgba(0, 0, 0, 0.06); }
.epx-dmn-expr__type-popover button.is-active { background: var(--epx-dmn-accent-bg); color: var(--epx-dmn-accent); }
`, "",{"version":3,"sources":["webpack://./../epx-dmn/src/expression/styles.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,2DAA2D;EAC3D,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA,wEAAwE;AACxE;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,4CAA4C;EAC5C,UAAU;EACV,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;EACvB,gDAAgD;EAChD,iBAAiB;AACnB;AACA,+BAA+B,oDAAoD,EAAE;;AAErF,4EAA4E;AAC5E;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,0DAA0D;EAC1D,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,iDAAiD;AACnD;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,4EAA4E;AAC5E;EACE,mCAAmC;EACnC,mDAAmD;EACnD,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kDAAkD;AACpD;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA,+BAA+B,oDAAoD,EAAE;;AAErF,4EAA4E;AAC5E;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,mDAAmD;EACnD,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;AACA,8BAA8B,kCAAkC,EAAE;AAClE;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,8BAA8B,iBAAiB,EAAE;;AAEjD,2EAA2E;AAC3E;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,6CAA6C;EAC7C,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA,sCAAsC,yCAAyC,EAAE;AACjF,0CAA0C,iCAAiC,EAAE,WAAW,EAAE;AAC1F;EACE,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA,uCAAuC,gBAAgB,EAAE;AACzD;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,sBAAsB;AACxB;AACA,kCAAkC,YAAY,EAAE;AAChD;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA,kCAAkC,mBAAmB,EAAE;AACvD;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA,+BAA+B,yCAAyC,KAAK,qCAAqC,EAAE;AACpH,+BAA+B,4CAA4C,EAAE,wCAAwC,EAAE;AACvH,+BAA+B,uCAAuC,OAAO,mCAAmC,EAAE;AAClH,+BAA+B,sCAAsC,QAAQ,kCAAkC,EAAE;AACjH,+BAA+B,oBAAoB,EAAE;AACrD;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,wCAAwC;AAC1C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,yCAAyC;EACzC,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;AACnB;AACA,iCAAiC,+BAA+B,EAAE;;AAElE;EACE,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,yCAAyC;EACzC,sDAAsD;EACtD,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA,2CAA2C,+BAA+B,EAAE;AAC5E,+CAA+C,oCAAoC,EAAE,4BAA4B,EAAE","sourcesContent":["@import url('../theme.css');\n\n.epx-dmn-expr {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: var(--epx-dmn-panel-bg);\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  color: var(--epx-dmn-panel-text);\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.epx-dmn-expr__wrap {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n}\n\n.epx-dmn-expr__main {\n  flex: 1;\n  min-width: 0;\n  overflow: auto;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.epx-dmn-expr__empty,\n.epx-dmn-expr__redirect,\n.epx-dmn-expr__placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  color: var(--epx-dmn-panel-text-faint);\n  font-style: italic;\n}\n.epx-dmn-expr__placeholder {\n  color: var(--epx-dmn-danger);\n}\n\n.epx-dmn-expr__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.epx-dmn-expr__title {\n  font-weight: 600;\n  font-size: 15px;\n  color: var(--epx-dmn-panel-text);\n}\n\n.epx-dmn-expr__type-chip {\n  display: inline-block;\n  padding: 2px 10px;\n  background: var(--epx-dmn-accent);\n  color: #fff;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  user-select: none;\n}\n.epx-dmn-expr__type-chip:hover {\n  background: var(--epx-dmn-accent-hover);\n}\n.epx-dmn-expr__type-chip--readonly {\n  background: var(--epx-dmn-panel-border);\n  color: var(--epx-dmn-panel-text-muted);\n  cursor: default;\n}\n.epx-dmn-expr__type-chip--readonly:hover {\n  background: var(--epx-dmn-panel-border);\n}\n\n.epx-dmn-expr__body {\n  display: block;\n}\n\n/* ── generic box ──────────────────────────────────────────────────────── */\n.epx-dmn-expr__box {\n  border: 1px solid var(--epx-dmn-grid-border);\n  background: var(--epx-dmn-panel-bg);\n  margin: 0;\n  display: inline-block;\n  min-width: 240px;\n  vertical-align: top;\n}\n.epx-dmn-expr__box--literal {\n  padding: 0;\n}\n\n/* Top-level boxed expression fills the available width of the editor. */\n.epx-dmn-expr__body > .epx-dmn-expr__box {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.epx-dmn-expr__grid {\n  border-collapse: collapse;\n  width: 100%;\n}\n.epx-dmn-expr__grid th,\n.epx-dmn-expr__grid td {\n  border: 1px solid var(--epx-dmn-grid-border);\n  padding: 0;\n  vertical-align: top;\n  background: var(--epx-dmn-panel-bg);\n  position: relative;\n}\n\n.epx-dmn-expr__name {\n  width: 140px;\n  min-width: 100px;\n  background: var(--epx-dmn-grid-header-bg);\n  font-weight: 600;\n}\n\n.epx-dmn-expr__name--result.epx-dmn-expr__editable--empty::before {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.epx-dmn-expr__cell {\n  padding: 0;\n  min-width: 180px;\n}\n\n.epx-dmn-expr__type {\n  width: 80px;\n  text-align: center;\n  background: var(--epx-dmn-grid-zebra);\n  vertical-align: middle;\n  padding: 2px 4px !important;\n}\n\n.epx-dmn-expr__index {\n  width: 26px;\n  min-width: 26px;\n  text-align: center;\n  background: var(--epx-dmn-grid-index-bg);\n  color: var(--epx-dmn-panel-text-muted);\n  font-weight: 600;\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n}\n.epx-dmn-expr__index:hover {\n  background: var(--epx-dmn-danger-soft);\n  color: var(--epx-dmn-danger);\n}\n\n.epx-dmn-expr__row-remove {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 16px;\n  height: 16px;\n  line-height: 14px;\n  font-size: 14px;\n  border: none;\n  background: transparent;\n  color: var(--epx-dmn-panel-text-muted);\n  cursor: pointer;\n  padding: 0;\n  border-radius: 50%;\n}\n.epx-dmn-expr__row-remove:hover {\n  background: var(--epx-dmn-danger);\n  color: #fff;\n}\n\n.epx-dmn-expr__add-row {\n  text-align: center;\n  color: var(--epx-dmn-accent);\n  cursor: pointer;\n  padding: 6px !important;\n  background: var(--epx-dmn-grid-zebra) !important;\n  user-select: none;\n}\n.epx-dmn-expr__add-row:hover { background: var(--epx-dmn-grid-header-bg) !important; }\n\n/* ── editable cells ───────────────────────────────────────────────────── */\n.epx-dmn-expr__editable {\n  display: block;\n  padding: 6px 8px;\n  min-height: 22px;\n  outline: none;\n  font-family: \"Menlo\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  cursor: text;\n}\n.epx-dmn-expr__editable:focus {\n  background: var(--epx-dmn-focus-bg);\n  box-shadow: inset 0 0 0 2px var(--epx-dmn-accent);\n}\n.epx-dmn-expr__editable--empty::before {\n  content: attr(data-placeholder);\n  color: var(--epx-dmn-panel-text-faint);\n}\n.epx-dmn-expr__name .epx-dmn-expr__editable {\n  font-family: inherit;\n  font-weight: 600;\n  padding: 6px 20px 6px 8px;\n}\n\n/* ── invocation ───────────────────────────────────────────────────────── */\n.epx-dmn-expr__box--invocation .epx-dmn-expr__invocation-header {\n  background: var(--epx-dmn-bkm-fill);\n  border-bottom: 1px solid var(--epx-dmn-grid-border);\n  padding: 0;\n}\n.epx-dmn-expr__invocation-name {\n  font-family: inherit !important;\n  font-weight: 700;\n  font-style: italic;\n}\n\n/* ── relation ─────────────────────────────────────────────────────────── */\n.epx-dmn-expr__relation thead th {\n  background: var(--epx-dmn-grid-header-bg);\n  font-weight: 600;\n}\n.epx-dmn-expr__relation-corner {\n  width: 26px;\n  background: var(--epx-dmn-panel-border) !important;\n}\n.epx-dmn-expr__relation-head {\n  min-width: 120px;\n  padding: 0 20px 0 4px !important;\n}\n.epx-dmn-expr__relation-tail {\n  width: 26px;\n  background: var(--epx-dmn-grid-zebra);\n}\n.epx-dmn-expr__add-col {\n  width: 26px;\n  text-align: center;\n  cursor: pointer;\n  background: var(--epx-dmn-grid-zebra) !important;\n  color: var(--epx-dmn-accent);\n  font-size: 16px;\n  user-select: none;\n}\n.epx-dmn-expr__add-col:hover { background: var(--epx-dmn-grid-header-bg) !important; }\n\n/* ── function definition ──────────────────────────────────────────────── */\n.epx-dmn-expr__box--function {\n  padding: 0;\n}\n.epx-dmn-expr__fn-params {\n  background: var(--epx-dmn-ks-fill);\n  border-bottom: 1px solid var(--epx-dmn-grid-border);\n  padding: 6px 8px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n.epx-dmn-expr__fn-label {\n  font-weight: 700;\n  color: var(--epx-dmn-ks-stroke);\n  margin-right: 8px;\n}\n.epx-dmn-expr__fn-param {\n  display: inline-flex;\n  align-items: center;\n  background: var(--epx-dmn-panel-bg);\n  border: 1px solid var(--epx-dmn-ks-stroke);\n  border-radius: 3px;\n  padding-right: 20px;\n  position: relative;\n}\n.epx-dmn-expr__fn-param .epx-dmn-expr__editable {\n  padding: 2px 8px;\n  font-family: inherit;\n  font-weight: 600;\n}\n.epx-dmn-expr__fn-typeref {\n  color: var(--epx-dmn-panel-text-muted);\n  padding-right: 2px;\n  font-size: 11px;\n}\n.epx-dmn-expr__fn-typeselect {\n  font-size: 11px;\n  padding: 1px 4px;\n  border: 1px solid var(--epx-dmn-input-border);\n  border-radius: 3px;\n  background: var(--epx-dmn-input-bg);\n  color: var(--epx-dmn-panel-text);\n  margin-right: 4px;\n}\n.epx-dmn-expr__fn-add {\n  background: none;\n  border: 1px dashed var(--epx-dmn-ks-stroke);\n  border-radius: 3px;\n  color: var(--epx-dmn-ks-stroke);\n  padding: 2px 8px;\n  cursor: pointer;\n}\n.epx-dmn-expr__fn-add:hover { background: var(--epx-dmn-ks-fill); }\n.epx-dmn-expr__fn-body {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.epx-dmn-expr__fn-body-type { margin-left: auto; }\n\n/* ── type picker ─────────────────────────────────────────────────────── */\n.epx-dmn-expr__type-picker {\n  display: inline-block;\n}\n.epx-dmn-expr__type-btn {\n  background: var(--epx-dmn-panel-bg);\n  border: 1px solid var(--epx-dmn-input-border);\n  border-radius: 3px;\n  font-size: 11px;\n  padding: 2px 6px;\n  cursor: pointer;\n  color: var(--epx-dmn-panel-text-muted);\n}\n.epx-dmn-expr__type-btn:hover {\n  background: var(--epx-dmn-accent-bg);\n  border-color: var(--epx-dmn-accent);\n  color: var(--epx-dmn-accent);\n}\n\n.epx-dmn-expr__type-menu {\n  position: fixed;\n  min-width: 180px;\n  background: var(--epx-dmn-panel-bg);\n  border: 1px solid var(--epx-dmn-panel-border);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  z-index: 10010;\n  padding: 4px 0;\n}\n.epx-dmn-expr__type-menu-item {\n  display: block;\n  width: 100%;\n  padding: 5px 14px;\n  font-size: 12px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  color: var(--epx-dmn-panel-text);\n}\n.epx-dmn-expr__type-menu-item:hover { background: var(--epx-dmn-grid-header-bg); }\n.epx-dmn-expr__type-menu-item.is-active { background: var(--epx-dmn-accent); color: #fff; }\n.epx-dmn-expr__type-menu-sep {\n  padding: 4px 14px 2px;\n  margin-top: 4px;\n  border-top: 1px solid var(--epx-dmn-panel-border);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--epx-dmn-panel-text-muted, #888);\n  pointer-events: none;\n  user-select: none;\n}\n\n/* ── EPX ML decision editor ─────────────────────────────────────────────── */\n.epx-dmn-expr__box--ml {\n  display: block;\n  padding: 8px;\n  background: var(--epx-dmn-panel-bg);\n  border: 1px solid #c41d7f;\n  border-radius: 4px;\n}\n.epx-dmn-expr__ml-section {\n  margin-bottom: 12px;\n}\n.epx-dmn-expr__ml-section:last-child { margin-bottom: 0; }\n.epx-dmn-expr__ml-section-title {\n  margin: 0 0 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #c41d7f;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.epx-dmn-expr__ml-field {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n.epx-dmn-expr__ml-field-label {\n  font-size: 12px;\n  color: var(--epx-dmn-panel-text);\n}\n.epx-dmn-expr__ml-input {\n  width: 100%;\n  font-size: 12px;\n  padding: 4px 6px;\n  border: 1px solid var(--epx-dmn-panel-border);\n  border-radius: 3px;\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-panel-text);\n  box-sizing: border-box;\n}\n.epx-dmn-expr__ml-input--number { width: 120px; }\n.epx-dmn-expr__ml-typeselect {\n  font-size: 12px;\n  padding: 3px 6px;\n  border: 1px solid var(--epx-dmn-panel-border);\n  border-radius: 3px;\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-panel-text);\n}\n.epx-dmn-expr__ml-grid th {\n  font-size: 11px;\n  font-weight: 600;\n  text-align: left;\n  padding: 4px 6px;\n  color: var(--epx-dmn-panel-text);\n  background: var(--epx-dmn-grid-header-bg);\n}\n.epx-dmn-expr__ml-tools {\n  margin-top: 6px;\n}\n.epx-dmn-expr__ml-suggest {\n  font-size: 11px;\n  padding: 4px 10px;\n  border: 1px solid #c41d7f;\n  background: #fff0f6;\n  color: #c41d7f;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.epx-dmn-expr__ml-suggest:hover { background: #ffd6e7; }\n.epx-dmn-expr__ml-radios {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n.epx-dmn-expr__ml-radio {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  cursor: pointer;\n}\n.epx-dmn-expr__ml-fallback-value {\n  margin-top: 4px;\n}\n\n/* nested boxes: don't double-border when a box sits inside a cell */\n.epx-dmn-expr__cell > .epx-dmn-expr__box {\n  display: block;\n  min-width: auto;\n  border: none;\n}\n.epx-dmn-expr__cell > .epx-dmn-expr__box--literal {\n  min-width: 180px;\n}\n\n/* ── FEEL chips (rendered inside .epx-dmn-expr__editable on blur) ─────── */\n.epx-dmn-feel-chip {\n  display: inline-block;\n  padding: 0 6px;\n  margin: 0 1px;\n  border-radius: 4px;\n  border: 1px solid var(--epx-dmn-panel-border);\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-panel-text);\n  font-weight: 600;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 11px;\n  line-height: 1.6;\n  vertical-align: baseline;\n  user-select: none;\n}\n.epx-dmn-feel-chip--input    { border-color: var(--epx-dmn-input-stroke);    background: var(--epx-dmn-input-fill); }\n.epx-dmn-feel-chip--decision { border-color: var(--epx-dmn-decision-stroke); background: var(--epx-dmn-decision-fill); }\n.epx-dmn-feel-chip--function { border-color: var(--epx-dmn-bkm-stroke);      background: var(--epx-dmn-bkm-fill); }\n.epx-dmn-feel-chip--param    { border-color: var(--epx-dmn-ks-stroke);       background: var(--epx-dmn-ks-fill); }\n.epx-dmn-feel-chip--self     { border-style: dashed; }\n.epx-dmn-feel-chip--known    {\n  border-color: var(--epx-dmn-accent);\n  background:   var(--epx-dmn-accent-bg-soft);\n  color:        var(--epx-dmn-accent-text);\n}\n.epx-dmn-feel-chip--unknown  {\n  border-color: var(--epx-dmn-unknown-stroke);\n  background:   var(--epx-dmn-unknown-soft);\n  color:        var(--epx-dmn-unknown-text);\n  border-style: dashed;\n  font-style:   italic;\n}\n.epx-dmn-feel-builtin {\n  color: var(--epx-dmn-bkm-stroke);\n  font-weight: 600;\n}\n\n/* ── FEEL syntax tokens (colors only, no chip box) ───────────────────── */\n.epx-dmn-feel-tok--keyword {\n  color: var(--epx-dmn-feel-keyword);\n  font-weight: 700;\n}\n.epx-dmn-feel-tok--literal {\n  color: var(--epx-dmn-feel-literal);\n  font-style: italic;\n}\n.epx-dmn-feel-tok--number {\n  color: var(--epx-dmn-feel-number);\n  font-weight: 600;\n}\n.epx-dmn-feel-tok--string {\n  color: var(--epx-dmn-feel-string);\n}\n.epx-dmn-feel-tok--op {\n  color: var(--epx-dmn-feel-op);\n  font-weight: 600;\n}\n.epx-dmn-feel-tok--punct {\n  color: var(--epx-dmn-panel-text-faint);\n}\n.epx-dmn-feel-tok--label {\n  color: var(--epx-dmn-panel-text-faint, #555);\n  font-weight: 600;\n}\n\n/* ── Chip de typeRef en context entries / invocation bindings ─────────── */\n.epx-dmn-expr__type-chip {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 6px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.04);\n  font-size: 11px;\n  color: var(--epx-dmn-panel-text-faint, #555);\n  cursor: pointer;\n  user-select: none;\n}\n.epx-dmn-expr__type-chip:hover { background: rgba(0, 0, 0, 0.08); }\n\n.epx-dmn-expr__type-popover {\n  position: absolute;\n  z-index: 1000;\n  background: var(--epx-dmn-panel-bg, #fff);\n  color: var(--epx-dmn-panel-text, #1e293b);\n  border: 1px solid var(--epx-dmn-panel-border, #d9d9d9);\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  padding: 4px;\n  min-width: 120px;\n}\n.epx-dmn-expr__type-popover button {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  padding: 4px 8px;\n  cursor: pointer;\n  border-radius: 3px;\n  font-size: 12px;\n}\n.epx-dmn-expr__type-popover button:hover { background: rgba(0, 0, 0, 0.06); }\n.epx-dmn-expr__type-popover button.is-active { background: var(--epx-dmn-accent-bg); color: var(--epx-dmn-accent); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
